// extracted by mini-css-extract-plugin
export default {"review_container":"ReviewList_review_container__v2hKD","details_section":"ReviewList_details_section__vvZDJ"};